import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const ParentService = {};

ParentService.getParents = function (params) {
  return fetch({
    url: ApiConstant.PARENT_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
ParentService.downalodParentExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.PARENT_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids }
  });
};
ParentService.getMyStudents = function (params) {
  return fetch({
    url: ApiConstant.PARENT_STUDENT_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
ParentService.deleteMyStudents = function (data, params) {
  return fetch({
    url: ApiConstant.PARENT_STUDENT_DELETE,
    method: "delete",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
ParentService.getSingleParent = function (params) {
  return fetch({
    url: ApiConstant.PARENT_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};

ParentService.editParent = function (data, params) {
  return fetch({
    url: ApiConstant.PARENT_UPDATE,
    method: "PUT",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
ParentService.editParentStatus = function (data, status) {
  const payload = {
    status: status,
    parent_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.PARENT_UPDATE_STATUS,
    method: "PUT",
    data: payload,
  });
};
ParentService.editParent = function (data, params) {
  return fetch({
    url: ApiConstant.PARENT_UPDATE,
    method: "PUT",
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
ParentService.editMyStudentBulkStatus = function (data, status) {
  const payload = {
    status: status,
    student_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.PARENT_STUDENT_UPDATE_STATUS,
    method: "PUT",
    data: payload,
  });
};
ParentService.editMyStudentStatus = function (data, params) {
  console.warn("data", data, "params", params);
  const payload = {
    status: data.status,
    student_ids: [params.student_id],
  };
  return fetch({
    url: ApiConstant.PARENT_STUDENT_UPDATE_STATUS,
    method: "PUT",
    data: payload,
  });
};

export default ParentService;
